import * as Utils from '../utilities/utils';

// Determines if a location in locationsData is currently selected
export function findSelectedLocation(state) {
  const locationsData = state.locationsData;
  const foundLocation = locationsData.find((location) => {
    const sameCountry = location.country === state.selectedCountry;
    const sameProvinceState = location.provinceState === state.selectedProvinceState;
    const sameCity = location.city === state.selectedCity;
    const sameFacility = getLocationName(location) === state.selectedFacility;
    return sameCountry && sameProvinceState && sameCity && (state.selectedCityUnique ? true : sameFacility);
  });
  return foundLocation;
}

export function findSelectedLocationId(state) {
  const locationsData = state.locationsData;

  const foundLocation = locationsData.find((location) => {
    return location.locationId === state.selectedLocationId;
  });
  return foundLocation;
}

// Returns an alphabetic list of countries
export function getCountryList(state) {
  const countries = state.locationsData.map((location) => {
    return location.country;
  });
  const uniqueCountries = Utils.uniqueArray(countries);
  const alphabeticCountries = uniqueCountries.sort();
  return alphabeticCountries;
}

// Returns an alphabetic list of provinces/states
export function getProvinceStateList(state) {
  const country = state.selectedCountry;
  const locationsInCountry = state.locationsData.filter((location) => {
    return location.country === country;
  });
  const provinceStates = locationsInCountry.map((location) => {
    return location.provinceState;
  });
  const uniqueProvinceStates = Utils.uniqueArray(provinceStates);
  const alphabeticProvinceStates = uniqueProvinceStates.sort();
  return alphabeticProvinceStates;
}

// Returns an alphabetic list of cities
export function getCitiesList(state) {
  const provinceState = state.selectedProvinceState;
  const locationsInProvinceState = state.locationsData.filter((location) => {
    return location.country === state.selectedCountry && location.provinceState === provinceState;
  });
  const cities = locationsInProvinceState.map((location) => {
    return location.city;
  });
  const uniqueCities = Utils.uniqueArray(cities);
  const alphabeticCities = uniqueCities.sort();
  return alphabeticCities;
}

// Display name should always be used if available
export function getLocationName(location) {
  return (location.displayName === '') ? `👻` : location.displayName;
}

// Returns an alphabetic list of facilities
export function getFacilitiesList(state) {
  const city = state.selectedCity;
  const locationsInCity = state.locationsData.filter((location) => {
    return (location.country === state.selectedCountry
      && location.provinceState === state.selectedProvinceState
      && location.city === city);
  });
  const facilities = locationsInCity.map((location) => {
    return getLocationName(location);
  });
  const uniqueCities = Utils.uniqueArray(facilities);
  const alphabeticFacilities = uniqueCities.sort();
  return alphabeticFacilities;
}
